import { AuthProvider } from './AuthProvider';
import { PasswiserLoginsSDK } from './AuthSDK';
import { AuthError, LoginFlow } from './types';
export { AuthProvider, PasswiserLoginsSDK, AuthError, LoginFlow };
// Prevent tree-shaking for AuthProvider in browser bundles
if (typeof window !== 'undefined') {
    // @ts-ignore
    window.__forceInclude = AuthProvider;
}
